import React from 'react';

export default class FileBase64 extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            files: [],
        };
    }

    handleChange(e) {


        // get the files
        let files = e.target.files;

        // Process each file
        var allFiles = [];
        for (var i = 0; i < files.length; i++) {


            this.props.onSelect();

            let file = files[i];

            let fileInfo = {
                name: file.name,
                type: file.type,
                size: file.size,
                file: file,
            };

            // Make new FileReader
            // let reader = new FileReader();

            // // Convert the file to base64 text
            // reader.readAsDataURL(file);

            // // on reader load somthing...
            // reader.onload = () => {

            //     // Make a fileInfo Object
            //     let fileInfo = {
            //         name: file.name,
            //         type: file.type,
            //         size: file.size,
            //         base64: reader.result,
            //         file: file,
            //     };

            //     // Push it to the state
                

            // } // reader.onload
            allFiles.push(fileInfo);

                // If all files have been proceed
                if (allFiles.length == files.length) {
                    // Apply Callback function
                    if (this.props.multiple) this.props.onDone(allFiles);
                    else this.props.onDone(this.props.index, allFiles[0]);
                }

        } // for

    }

    render() {
        return (
            <input
                type="file"
                id = {this.props.id}
                accept="application/pdf"
                onChange={this.handleChange.bind(this)}
                multiple={this.props.multiple} />
        );
    }
}

FileBase64.defaultProps = {
    multiple: false
};